// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymentCompleted-topLinkContainer-OlGWn {
    text-align: start;
}

.paymentCompleted-paymentCompletedImgContainer-nlx1j {
    position: relative;
    width: 100%;
    max-width: 560px;
    height: 371px;
    margin: 0 auto;
}

@media (max-width: 575px) {
    .paymentCompleted-paymentCompletedImgContainer-nlx1j {
        max-width: 100%;
        height: 223px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PaymentCompleted/paymentCompleted.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI;QACI,eAAe;QACf,aAAa;IACjB;AACJ","sourcesContent":[".topLinkContainer {\n    text-align: start;\n}\n\n.paymentCompletedImgContainer {\n    position: relative;\n    width: 100%;\n    max-width: 560px;\n    height: 371px;\n    margin: 0 auto;\n}\n\n@media (max-width: 575px) {\n    .paymentCompletedImgContainer {\n        max-width: 100%;\n        height: 223px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topLinkContainer": `paymentCompleted-topLinkContainer-OlGWn`,
	"paymentCompletedImgContainer": `paymentCompleted-paymentCompletedImgContainer-nlx1j`
};
module.exports = ___CSS_LOADER_EXPORT___;
